/**
 * components/landing/trust/TrustPage.jsx — Phase 11 · Trust Center
 * orchestrator.  Composes the ten trust-building sections in order.
 *
 * Section order is deliberate:
 *   1  Hero              — first impression + live status pill
 *   2  LiveStatus        — expanded status band (region + metrics)
 *   3  SecurityOverview  — the six security pillars
 *   4  PrivacyCommitment — the four privacy principles
 *   5  DataProtection    — the data lifecycle visual
 *   6  PlatformAvailability — uptime, RPO/RTO, DR
 *   7  ComplianceRoadmap — honest posture matrix (no overclaim)
 *   8  LegalPolicies     — placeholder cards → future /trust/* routes
 *   9  SecurityFAQ       — accordion of common enterprise questions
 *  10  FinalCTA          — link to /contact?topic=security
 */

import SiteFrame       from '@/components/landing/SiteFrame'
import Hero                from './sections/Hero'
import LiveStatus          from './sections/LiveStatus'
import SecurityOverview    from './sections/SecurityOverview'
import PrivacyCommitment   from './sections/PrivacyCommitment'
import DataProtection      from './sections/DataProtection'
import PlatformAvailability from './sections/PlatformAvailability'
import ComplianceRoadmap   from './sections/ComplianceRoadmap'
import LegalPolicies       from './sections/LegalPolicies'
import SecurityFAQ         from './sections/SecurityFAQ'
import FinalCTA            from './sections/FinalCTA'

const TrustPage = () => (
  <SiteFrame hideFooterCta={true}>
    <Hero />
    <LiveStatus />
    <SecurityOverview />
    <PrivacyCommitment />
    <DataProtection />
    <PlatformAvailability />
    <ComplianceRoadmap />
    <LegalPolicies />
    <SecurityFAQ />
    <FinalCTA />
  </SiteFrame>
)

export default TrustPage
